'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import posthog from 'posthog-js';
import { useEffect } from 'react';

export function PostHogPageView() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const trackExternalPixels = () => {
      try {
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        (window as any).fbq?.('track', 'PageView');
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        (window as any).rdt('track', 'PageVisit');
      } catch (error) {
        console.error('Error tracking page view', error);
      }
    };

    if (pathname) {
      trackExternalPixels();
      let url = pathname;
      if (searchParams?.toString()) {
        url = `${pathname}?${searchParams.toString()}`;
      }

      posthog.capture('$pageview', {
        $current_url: url,
      });
    }
  }, [pathname, searchParams]);

  return null;
}
